module.exports = __webpack_public_path__ + "media/images/bus/conditions/MAGA-23d5f42dcd920b80eb4a257e5b56b8dd.svg";